module.exports = __webpack_public_path__ + "img/silae-papillon.b2ce0d6e.svg";